/**
 * Created by rickborst on 25/04/2017.
 */

import _ from 'lodash';
import qs from 'qs';

import Config from 'config';

import {convertImageFromRead, convertImagesFromRead} from './images';
import {convertFromRead as convertPlaybackRulesFromRead} from './playbackrules';
import {convertFromRead as convertMediaFromRead} from './assets/media';
import {convertFromRead as convertTagsFromRead} from './assets/tags';
import {convertFromRead as convertMetaDataFromRead} from './assets/metadata';

import {
    BroadcastTypes,
    ProgramTypes,
    AssetTypes
} from 'models/asset';

const getType = function (type) {
        let assetTypes = this._presets.assetTypes;

        switch (type) {

            case assetTypes[AssetTypes.EPG_ITEM]:
                return AssetTypes.EPG_ITEM;

            case assetTypes[AssetTypes.EPISODE]:
                return AssetTypes.EPISODE;

            case assetTypes[AssetTypes.SERIES]:
                return AssetTypes.SERIES;

            case assetTypes[AssetTypes.LINEAR]:
                return AssetTypes.LINEAR;

            case assetTypes[AssetTypes.SPORT]:
                return AssetTypes.SPORT;

            case assetTypes[AssetTypes.LEAGUE]:
                return AssetTypes.LEAGUE;

            case assetTypes[AssetTypes.MOVIE]:
                return AssetTypes.MOVIE;

            default:
                return AssetTypes.UNKNOWN;
        }
    },

    getProgramType = function (programType) {

        switch (programType.toLowerCase()) {

            case 'match':
                return ProgramTypes.MATCH;

            case 'show':
                return ProgramTypes.SHOW;

            case 'news':
                return ProgramTypes.NEWS;

            case 'documentary':
                return ProgramTypes.DOCUMENTARY;

            case 'original':
                return ProgramTypes.ORIGINAL;

            case 'magazine':
                return ProgramTypes.MAGAZINE;

            case 'recap':
                return ProgramTypes.RECAP;

            default:
                return ProgramTypes.UNKNOWN;
        }
    },

    getBroadcastType = function (broadcastType) {

        switch (broadcastType.toLowerCase()) {

            case 'live':
                return BroadcastTypes.LIVE;

            case 'catch-up':
            case 'catchup':
                return BroadcastTypes.CATCH_UP;

            default:
                return BroadcastTypes.REGULAR;
        }
    },

    getImageMap = function (images) {
        let asset = [],
            league,
            team1,
            team2;

        _.forEach(images, image => {

            switch (image.ratio) {

                case 'TeamLogo':
                    team1 = image;
                    break;

                case 'vsTeamLogo':
                    team2 = image;
                    break;

                case 'LeaugeLogo': // TODO: Remove when typo is fixed
                case 'LeagueLogo':
                    league = image;
                    break;

                case '16:9':
                default:
                    asset.push(image);
                    break;
            }
        });

        return {
            asset: asset || null,
            league: league || null,
            team1: team1 || null,
            team2: team2 || null
        };
    },

    getQuery = function (data) {
        let assetReferenceType;

        switch (data.type) {
            case AssetTypes.LINEAR:
            case AssetTypes.EPG_ITEM:
                assetReferenceType = 'Epg_internal';
                break;

            default:
                assetReferenceType = 'Media';
                break;
        }

        return qs.stringify({
            assetReferenceType: assetReferenceType
        });
    };

/**
 * Converts asset data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Asset data.
 */
export function convertFromRead (data = {}) {

    let metaData = convertMetaDataFromRead.call(this, data.metas),
        imageMap = getImageMap.call(this, data.images),
        convertedData = {
            id: data.id || '',
            title: data.name || '',
            subTitle: metaData.subTitle || '',
            description: data.description || '',
            episodeNumber: metaData.episodeNumber || '',
            seriesId: metaData.seriesId || '',
            seriesName: metaData.seriesName || '',
            type: getType.call(this, data.type),
            images: convertImagesFromRead.call(this, imageMap.asset),
            media: convertMediaFromRead.call(this, data.mediaFiles),
            start: data.startDate ? data.startDate * 1000 : null,
            end: data.endDate ? data.endDate * 1000 : null,
            matchInfo: {
                league: {
                    name: metaData.league || '',
                    image: imageMap.league
                        ? convertImageFromRead.call(this, imageMap.league)
                        : null
                },
                team1: {
                    name: metaData.team1 || '',
                    image: imageMap.team1
                        ? convertImageFromRead.call(this, imageMap.team1)
                        : null
                },
                team2: {
                    name: metaData.team2 || '',
                    image: imageMap.team2
                        ? convertImageFromRead.call(this, imageMap.team2)
                        : null
                },
                location: metaData.location || '',
                sportType: metaData.sportType || ''
            },
            programType: getProgramType.call(this, metaData.programType || ''),
            broadcastType: getBroadcastType.call(this, metaData.broadcastType || ''),
            tags: convertTagsFromRead.call(this, data.tags),
            rating: metaData.rating || '',
            playbackRules: convertPlaybackRulesFromRead.call(this, data),
            apiSpecifics: {
                crid: data.crid || '',
                epgId: data.epgId || '',
                epgChannelId: data.epgChannelId || '',
                linearAssetId: data.linearAssetId || '',
                relatedMediaId: data.relatedMediaId || '',
                houseNumber: metaData.houseNumber || '',
                priority: metaData.priority || '',
                location: metaData.location || ''
            },
            query: ''
        };

    convertedData.query = getQuery(convertedData);

    return convertedData;
}

/**
 * Converts assets data from read data.
 *
 * @param {Array} [data] - Read data.
 * @returns {Array} Assets data.
 */
export function convertAssetsFromRead (data = []) {

    if (!_.isArray(data)) {
        data = [data];
    }

    return _.map(data, convertFromRead.bind(this));
}

/**
 * Converts application data for getAsset request.
 *
 * @param {number} id - Asset id.
 * @param {string} query - Asset query.
 * @returns {Object} Request data.
 */
export function convertForGetAsset (id, query) {
    const configData = Config.dataSources.kaltura,
        queryData = qs.parse(query);

    return {
        id: id,
        apiVersion: configData.APIVersion,
        ...queryData
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/assets.js